/**
 * Headless youtube video loader from id
 * Burak Doğan <burak@platinmarket.com>
 */

(function(win, doc) {
    'use strict';
    
    /**
     * Youtube api loader
     */
    var loadYoutubePlayer = function() {
        return new Promise(function(resolve){
            if ($(doc).find('#ytb_script').length) return resolve();
            win['onYouTubePlayerAPIReady'] = function(){ resolve(); };
            var tag = doc.createElement('script');
            tag.id = 'ytb_script';
            tag.src = 'https://www.youtube.com/player_api';
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        });
    }

    var listItemTemplate = function(index, item){
        return "<li><a href='#' class='ytv-clear' data-target='#yt_video_" + index + "'><div class='ytv-thumb'><img src='https://img.youtube.com/vi/" + item.getVideoData().video_id + "/mqdefault.jpg' /></div><div class='ytv-content'>" + item.getVideoData().title + "</div></a></li>";
    }

    /**
     * Jquery plugin
     */
    jQuery.fn.extend({
        ytv: function(options) {
            var _targetHolder = this;
            _targetHolder.addClass('ytv-canvas');
            loadYoutubePlayer().then(function(){
                _targetHolder.each(function(){
                    var target = $(this);
                    target.append("<div class='ytv-relative'><div class='ytv-video'></div><div class='ytv-list'><div class='ytv-list-inner' style='top:0px;'><ul></ul></div></div></div>");
                    var players = options.videos.map(function(id, i){
                        var elId = "yt_video_" + i;
                        var container = $("<div class='yt_video' id='" + elId + "'></div>");
                        target.find('.ytv-video').append(container);
                        target.find('.ytv-list ul').append("<li style='display:none;' id='ytv-list-item-" + id + "'></li>");
                        // Crate video
                        return new YT.Player(container[0], {
                            height: '360',
                            width: '100%',
                            videoId: id,
                            events: {
                                'onReady': function(event){
                                    // Create list item
                                    var item = $(listItemTemplate(i, event.target));
                                    item.find("[data-target]").on('click', function(evt){
                                        evt.preventDefault();
                                        if ($(this).parent().hasClass('ytv-active')) return;
                                        players.filter(function(p){ return p && p.pauseVideo && p !== event.target; }).forEach(function(p){ p.pauseVideo(); });
                                        if (evt.originalEvent && event.target.getPlayerState() !== 1) event.target.playVideo();
                                        target.find('.ytv-list ul li.ytv-active').removeClass('ytv-active');
                                        $(this).parent().addClass('ytv-active');
                                        target.find('.ytv-video').children().hide();
                                        target.find('.ytv-video').find($(this).attr('data-target')).show();
                                    });
                                    target.find('.ytv-list ul li#ytv-list-item-' + event.target.getVideoData().video_id).replaceWith(item);
                                    target.find('.ytv-list ul > li:first-child a').trigger('click');
                                },
                            }
                        });
                    });
                });
            });
            return this;
        }
    });

}).call(this, window, document);
